var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 35,
      height: 27
    },
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8198 1.68668C34.934 1.59526 35 1.4603 35 1.31804C35 1.05232 34.7742 0.836914 34.4957 0.836914H0.782803C0.350473 0.836914 0 1.17131 0 1.58381C0 1.80585 0.103543 2.01638 0.282536 2.15828L16.7176 15.1875C17.0757 15.4714 17.5954 15.4703 17.9522 15.1848L34.8198 1.68668ZM1.57892 5.97431C0.951242 5.47671 0 5.90261 0 6.68125V25.6531C0 26.1607 0.431285 26.5722 0.963302 26.5722H34.0367C34.5687 26.5722 35 26.1607 35 25.6531V6.31198C35 5.53136 34.0445 5.10612 33.4177 5.60776L18.0617 17.8962L17.959 17.9784C17.6022 18.2639 17.0825 18.2651 16.7243 17.9811L16.6212 17.8994L1.57892 5.97431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e24fb6ec17f9e97a03ebfe45dcc94ffb.svg";
export { ForwardRef as ReactComponent };